import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionGuard implements CanActivate {
  constructor(
    private router: Router,
    private subscriptionRestrictionService: SubscriptionRestrictionService,
  ) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (this.subscriptionRestrictionService.checkSubscriptionHasBlockingRestriction(true)){
            if (!this.subscriptionRestrictionService.canCurrentUserAccessSubscription()) {
                return false
            }
            this.router.navigate(['/configuracao/assinatura'])
            return false
        }
        return true
       
  }
}
